/* Pagina prodotto: il clic sulla foto ingrandisce sul posto (niente schermo intero). Si esplora muovendo il mouse o il dito. */
(function () {
  if (window.__dcZoom) return;
  window.__dcZoom = true;
  var SCALE = 2.2;
  var cur = null;

  function origin(media, x, y) {
    var r = media.getBoundingClientRect();
    var px = Math.max(0, Math.min(100, ((x - r.left) / r.width) * 100));
    var py = Math.max(0, Math.min(100, ((y - r.top) / r.height) * 100));
    var img = media.querySelector('img');
    if (img) img.style.transformOrigin = px + '% ' + py + '%';
  }
  function off() {
    if (!cur) return;
    cur.classList.remove('is-zoomed');
    var img = cur.querySelector('img');
    if (img) img.style.transform = '';
    cur = null;
  }
  function on(media, x, y) {
    off();
    cur = media;
    origin(media, x, y);
    var img = media.querySelector('img');
    if (img) img.style.transform = 'scale(' + SCALE + ')';
    media.classList.add('is-zoomed');
  }

  document.addEventListener('click', function (e) {
    var op = e.target.closest && e.target.closest('.product__modal-opener--image');
    if (!op) { if (cur && !(e.target.closest && e.target.closest('.product__media'))) off(); return; }
    // ferma l'apertura a tutto schermo del tema
    e.preventDefault();
    e.stopPropagation();
    var media = op.querySelector('.product__media');
    if (!media) return;
    if (media === cur) off(); else on(media, e.clientX, e.clientY);
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (!cur) return;
    var r = cur.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) {
      if (e.pointerType === 'mouse') off();
      return;
    }
    origin(cur, e.clientX, e.clientY);
  }, { passive: true });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') off(); });
  window.addEventListener('scroll', function () { if (cur && window.matchMedia('(hover: none)').matches) off(); }, { passive: true });
})();

/* Foto per variante: scegliendo una variante restano visibili solo le sue foto (quella assegnata alla variante
   e quelle che hanno il nome della variante nel testo alternativo) più le foto comuni a tutte. */
(function () {
  if (window.__dcVMedia) return;
  window.__dcVMedia = true;
  // il "+" resta attaccato: "JC233+CW10" è un nome di variante unico, diverso da "CW10"
  function norm(t) { return ' ' + String(t || '').toLowerCase().replace(/\s*\+\s*/g, '+').replace(/[^a-z0-9àèéìòù+]+/g, ' ').trim() + ' '; }
  function setup(s) {
    if (s.dataset.done) return;
    s.dataset.done = '1';
    var sec = s.getAttribute('data-dc-vmedia');
    var d;
    try { d = JSON.parse(s.textContent); } catch (e) { return; }
    var owners = {};
    d.media.forEach(function (m) {
      var alt = norm(m.alt);
      owners[m.id] = d.variants.filter(function (v) {
        return v.media === m.id || v.options.some(function (o) { var n = norm(o); return n.trim().length >= 2 && alt.indexOf(n) >= 0; });
      }).map(function (v) { return v.id; });
    });
    function current() {
      var inp = document.querySelector('#product-form-' + sec + ' input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var id = inp ? Number(inp.value) : 0;
      return d.variants.some(function (v) { return v.id === id; }) ? id : d.variants[0].id;
    }
    function apply() {
      var vid = current();
      var first = 0;
      d.media.forEach(function (m) {
        var own = owners[m.id];
        var show = !own.length || own.indexOf(vid) >= 0;
        if (show && !first) first = m.id;
        document.querySelectorAll('[id="Slide-' + sec + '-' + m.id + '"], [data-target="' + sec + '-' + m.id + '"]').forEach(function (el) { el.classList.toggle('dc-vhide', !show); });
      });
      var gal = document.getElementById('MediaGallery-' + sec);
      var act = gal && gal.querySelector('.product__media-item.is-active');
      if (gal && (!act || act.classList.contains('dc-vhide'))) {
        var v = d.variants.filter(function (x) { return x.id === vid; })[0];
        var target = v && v.media ? v.media : first;
        if (target && typeof gal.setActiveMedia === 'function') { try { gal.setActiveMedia(sec + '-' + target, true); } catch (e) { /* ignore */ } }
      }
      ['GalleryViewer-', 'GalleryThumbnails-'].forEach(function (p) {
        var sl = document.getElementById(p + sec);
        if (sl && typeof sl.initPages === 'function') {
          try {
            sl.initPages();
            // su telefono il tema contava una foto in più: il totale è il numero di foto visibili
            if (p === 'GalleryViewer-' && sl.slidesPerPage === 0 && sl.sliderItemsToShow) { sl.totalPages = sl.sliderItemsToShow.length; if (typeof sl.update === 'function') sl.update(); }
          } catch (e) { /* ignore */ }
        }
      });
    }
    apply();
    window.addEventListener('load', apply);
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-radios, variant-selects')) { setTimeout(apply, 60); setTimeout(apply, 700); }
    });
  }
  function init() { document.querySelectorAll('script[data-dc-vmedia]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
